// src/components/molecules/admin/users/UserConsentsSummary.jsx
// Dark‑theme – layout identico a "ContactInfoUser" (4 colonne).
// No dipendenze esterne: formato data via native Date.

import React from 'react';
import { useTranslation } from 'react-i18next';

const titleCls = 'uppercase text-[#A0A0A0] text-xs tracking-wide';
const descCls  = 'text-xs text-white font-manrope';
const dash     = <span className={descCls}>—</span>;

function fmt(ts) {
  if (!ts) return ''; // già gestito da dash
  const d = new Date(ts);
  const pad = (n) => n.toString().padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default function UserConsentsSummary({ consents = [] }) {
  const { t } = useTranslation();
  const map = Object.fromEntries(consents.map((c) => [c.consent_type, c]));
  const LABELS = {
    TERMS_PRIVACY: t('TERMS_PRIVACY'),
    MARKETING: t('MARKETING'),
    TERMS_PRIVACY_UPDATE: t('TERMS_PRIVACY_UPDATE'),
  };
  return (
    <div className="grid grid-cols-4 pb-10 border border-solid border-b border-t-0 border-l-0 border-r-0 border-[#FFFFFF29]">
      {/* titolo sezione (colonna 1) */}
      <span className="text-white font-manrope text-2xl">
        {t('Legal_Consents')}
      </span>

      {/* colonne 2‑4: TC+PP, Marketing, Update */}
      {['TERMS_PRIVACY', 'MARKETING', 'TERMS_PRIVACY_UPDATE'].map((key) => {
        const c = map[key];
        return (
          <div key={key} className="flex flex-col gap-1 items-start">
            <span className={titleCls}>{LABELS[key]}</span>

            {c ? (
              <>
                <span className='text-white text-xl font-manrope'>
                  {c.accepted ? t('Accepted') : t('Denied')}
                </span>
                <span className={descCls}>{fmt(c.accepted_at)}</span>
                <span className={descCls}>{c.version_id}</span>
              </>
            ) : (
              dash
            )}
          </div>
        );
      })}
    </div>
  );
}
